export default __webpack_public_path__ + "static/media/755.dd3764fd.png";